import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import './securityMeasures.scss';
import { AiIcon, NetworkIcon, SslIcon } from 'src/assets';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const SecurityMeasures = () => {
  const { t } = useTranslation();

  const options = [
    {
      icon: SslIcon,
      title: 'securityMeasures:ssl:title',
      sub: 'securityMeasures:ssl:sub',
    },
    {
      icon: NetworkIcon,
      title: 'securityMeasures:network:title',
      sub: 'securityMeasures:network:sub',
    },
    {
      icon: AiIcon,
      title: 'securityMeasures:ai:title',
      sub: 'securityMeasures:ai:sub',
    },
  ];

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  return (
    <div className="security-measures">
      <div className={`security-measures-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
        <div className="security-measures-title">
          <supertitle>{t('title:aboutUs')}</supertitle>
          <h1>
            <blue-underline>{t('securityMeasures:measures')}</blue-underline>{' '}
            <blue-text>{t('securityMeasures:security')}</blue-text>
          </h1>
        </div>

        <div className="security-measures-section">
          {options.map((item, index) => (
            <div className="security-measures-item" key={index}>
              <div className="security-measures-item-image">
                <img src={item.icon} alt={item.icon} />
              </div>
              <h3>{t(item.title)}</h3>
              <text>{t(item.sub)}</text>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
